<template>
  <div class="answer">
    <div class="title">解答：</div>
    <div class="content">
      {{ row.answer }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    row: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.answer {
  background: #fffafa;
  padding: 10px 15px;
  border-radius: 5px;
  .title {
    font-weight: bold;
    margin-bottom: 10px;
  }
  .content {
    line-height: 2em;
  }
}
</style>